export type PortalRole = 'admin' | 'commercial' | 'coach' | 'support';

export const PORTAL_ROLE_LABELS: Record<PortalRole, string> = {
  admin: 'Administradora',
  commercial: 'Comercial',
  coach: 'Professora',
  support: 'Suporte',
};

export interface PortalUser {
  id: number;
  user_id: string;
  roles: PortalRole[];
  created_at: string;
  full_name: string;
  is_active: boolean;
}

export interface CreatePortalUserPayload {
  user_id: string;
  roles: PortalRole[];
  full_name: string;
  is_active: boolean;
}

export interface PortalUsersFilters {
  search?: string;
}

export interface PortalUserEditData {
  user_id: string;
  full_name: string;
  email: string;
  roles: PortalRole[];
  is_active: boolean;
}

export interface PortalAccountProfile {
  user_id: string;
  full_name: string;
  email: string;
  is_active: boolean;
  roles: PortalRole[];
}
